import { render, staticRenderFns } from "./EditSidebar.vue?vue&type=template&id=26b79225&scoped=true&"
import script from "./EditSidebar.vue?vue&type=script&lang=js&"
export * from "./EditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditSidebar.vue?vue&type=style&index=0&id=26b79225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b79225",
  null
  
)

export default component.exports